import React from 'react';
import { Modal } from '../ui/Modal';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const MenuNotAvailableModal = ({
  isOpen,
  onClose,
  messageKey = 'menu_unavailable_modal_message',
}) => {
  const { language } = useDataContext();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="text-center space-y-4">
        <h4 className="text-lg sm:text-xl">Whoops! 👀</h4>
        <p className="text-sm sm:text-base">{translations[language]?.[messageKey]}</p>
        <button
          className="w-full sm:w-[200px] bg-primary text-sm text-white font-bold px-4 py-[12px] rounded-full hover:bg-secondary transition-colors"
          onClick={onClose}
        >
          {translations[language]?.close}
        </button>
      </div>
    </Modal>
  );
};

export default MenuNotAvailableModal;
